import { TabContainer } from '../tab-container/tab-container';
export default TabContainer;
